import React from 'react';
import { Input, InputAdornment } from '@material-ui/core';
import BaseInputWrapper from '../BaseInputWrapper';
import useDefaultInputHook from '../hooks/useDefaultInputHook/useDefaultInputHook';
import NumberFormatCustom from '../helpers/NumberFormatCustom';
import InputProps from '../InputProps';

const MoneyField = ({
  inputName,
  inputLabel,
  onChange,
  defaultValue,
  inputError = false,
  inputErrorMessage = '',
  isDisabled = false,
  inputId = '',
  currencySelected = 'USD',
}: InputProps<number>): JSX.Element => {
  let stringValue = '';
  if (typeof defaultValue !== 'undefined' && !Number.isNaN(defaultValue)) {
    stringValue = defaultValue.toString();
  }
  const { currentClass, decoration, onInputChanged, onBlur } =
    useDefaultInputHook(inputError, stringValue);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const newValue = event.target.value;
    onInputChanged(newValue);
    onChange(parseFloat(event.target.value));
  };

  return (
    <BaseInputWrapper
      inputId={inputId}
      label={inputLabel}
      error={inputError}
      errorMessage={inputErrorMessage}
    >
      <Input
        id={inputId}
        name={inputName}
        className={currentClass}
        disabled={isDisabled}
        value={stringValue}
        onChange={handleChange}
        onBlur={onBlur}
        endAdornment={
          <InputAdornment position="end">{decoration}</InputAdornment>
        }
        // As per official documentation example, this must be casted as 'any'.
        // Refer to https://material-ui.com/components/text-fields/#textfield, the
        // section 'Integration with 3rd party input libraries'
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        inputComponent={NumberFormatCustom as any}
        inputProps={{
          prefix:
            currencySelected === 'CRC' || currencySelected === '₡' ? '₡' : '$',
        }}
      />
    </BaseInputWrapper>
  );
};

export default MoneyField;
